import * as findItemShapeUtil from './utils/findItemShapeUtil';
import findItemRequest from 'owa-service/lib/factory/findItemRequest';
import findItemOperation from 'owa-service/lib/operation/findItemOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
/**
 * Configure the request body
 * @param currentBaseFolderId the current base folder id
 * @param paging the paging type
 * @param viewFilter the view filter
 * @param sortResults the primary and secondary sort by results
 * @param focusedViewFilter the focused view filter
 * @param findItemShapeName the request shape name
 * @param categoryName the category name
 * @param traversal the traverl to use for this find request
 * @return FindItem request
 */
function configureRequestBody(currentBaseFolderId, paging, viewFilter, sortResults, focusedViewFilter, findItemShapeName, categoryName, traversal) {
    var folderId = currentBaseFolderId;
    return findItemRequest({
        ParentFolderIds: [currentBaseFolderId],
        ItemShape: findItemShapeUtil.getFindItemResponseShape(folderId.Id),
        ShapeName: findItemShapeName,
        Traversal: traversal,
        Paging: paging,
        FocusedViewFilter: focusedViewFilter,
        ViewFilter: viewFilter,
        SortOrder: sortResults,
        CategoryFilter: categoryName,
    });
}
/**
 * Find item request
 * @param baseFolderId the base folder id
 * @param paging the paging type
 * @param viewFilter the view filter
 * @param sortResults the primary and secondary sort by results
 * @param focusedViewFilter the focused view filter
 * @param findItemShapeName the request shape name
 * @param options - optional parameters to be passed to request (method and/or headers)
 * @param categoryName the category name
 * @param traversal the traverl to use for this find request
 * @return promise containing FindItem response
 */
export function findItem(baseFolderId, paging, viewFilter, sortResults, focusedViewFilter, findItemShapeName, options, categoryName, traversal) {
    if (categoryName && viewFilter != 'UserCategory') {
        throw new Error('CategoryName should be set only for UserCategory view filter');
    }
    var requestBody = configureRequestBody(baseFolderId, paging, viewFilter, sortResults, focusedViewFilter, findItemShapeName, categoryName, traversal);
    return findItemOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }, options).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
//# sourceMappingURL=findItem.js.map